import { Table } from 'dexie'
import { FunnelId } from 'modules/funnels/types/funnel-interface'

export interface FunnelsInterface {
  funnelId: FunnelId
  stepId: number | null
}

export type FunnelsTableType = {
  funnels: Table<FunnelsInterface, FunnelId>
}

export const funnelSchema = {
  funnels: 'funnelId, stepId',
}
